export const UNSPLASH_MAX_WIDTH = 600;
export const UNSPLASH_MAX_WIDTH_BANNER = 1440;

export const RESET_TO_DEFAULT = "reset_to_default";

export const DEFAULT_BACKGROUND = "default_background";

export const IMAGE_SOURCE_TYPES = {
  COMPANY_IMAGES: "company_images",
  STOCK_IMAGES: "stock_images",
  COLOR_PICKER: "color_picker",
};

export const PREVIEW_POSITIONS = {
  LEFT: "left",
  BOTTOM: "bottom",
};

export const LAYOUT_MODES = {
  AVATAR: "avatar",
  BACKGROUND: "background",
};

export const CROP_DATA_FIELD = {
  CROP_AREA: "cropArea",
  CROP_DATA: "cropData",
};

/**
 * Get layout-specific configuration for image cropping
 * @param {string} layoutMode - Either 'avatar' or 'background'
 * @returns {Record<string, any>} Configuration object with aspectRatio, imageHeight, previewPosition, maxImageWidth, cropDataField
 */
export const getLayoutConfig = (layoutMode) => {
  if (layoutMode === LAYOUT_MODES.AVATAR) {
    return {
      aspectRatio: 1,
      imageHeight: 300,
      previewPosition: PREVIEW_POSITIONS.LEFT,
      maxImageWidth: UNSPLASH_MAX_WIDTH,
      cropDataField: CROP_DATA_FIELD.CROP_AREA, // Use cropArea for avatar (percentage-based)
    };
  }

  // Default to background mode
  return {
    aspectRatio: 0,
    imageHeight: 90,
    previewPosition: PREVIEW_POSITIONS.BOTTOM,
    maxImageWidth: UNSPLASH_MAX_WIDTH_BANNER,
    cropDataField: CROP_DATA_FIELD.CROP_DATA, // Use cropData for background (pixel-based)
  };
};
